import { useEffect, useRef } from 'react';
import { useQuery } from 'shared/helpers/RoutingHelpers';
import { openExternalURL } from 'shared/helpers/URLHelpers';
import { useRedirectToTMSLanding } from 'shared/routing/TMSLandingPath';
import { getAuthToken } from './AuthToken';
import { useLocation } from 'react-router-dom';

interface RedirectToTMSProps {
  children: React.ReactElement;
}

function isPasswordResetDeepLink(location: {
  pathname: string;
  search: string;
}): boolean {
  if (location.pathname.endsWith('/login/reset-password')) {
    return true;
  }

  return new URLSearchParams(location.search).has('reset_code');
}

export function RedirectToTMS({ children }: RedirectToTMSProps) {
  const authToken = getAuthToken();
  const [{ next }] = useQuery();
  const location = useLocation();
  const { redirectToTMSLanding } = useRedirectToTMSLanding();
  const hasRedirected = useRef(false);

  const shouldRedirect = !!authToken && !isPasswordResetDeepLink(location);

  useEffect(() => {
    if (!shouldRedirect || hasRedirected.current) return;
    hasRedirected.current = true;

    if (next) {
      openExternalURL(next);
    } else {
      redirectToTMSLanding();
    }
  }, [shouldRedirect, next, redirectToTMSLanding]);

  return children;
}
